import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthenticationService } from 'src/app/shared/services/api/authentication/authentication.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
})
export class VerifyEmailComponent implements OnInit, OnDestroy {
  email = '';
  resendState: 'idle' | 'sending' | 'sent' = 'idle';
  cooldown = 0;

  private cooldownInterval: ReturnType<typeof setInterval> | null = null;
  private resetTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    const nav = this.router.getCurrentNavigation();
    this.email = nav?.extras?.state?.['email'] || history.state?.email || '';

    if (!this.email) {
      this.router.navigate(['/register']);
    }
  }

  ngOnDestroy(): void {
    if (this.cooldownInterval) clearInterval(this.cooldownInterval);
    if (this.resetTimeout) clearTimeout(this.resetTimeout);
  }

  async handleResend(): Promise<void> {
    if (this.resendState === 'sending' || this.cooldown > 0) return;

    this.resendState = 'sending';

    try {
      await firstValueFrom(this.authenticationService.forgotPassword(this.email));
    } catch {
      // Silently handle -- the email was already sent once successfully
    }

    this.resendState = 'sent';
    this.cooldown = 60;
    this.startCooldown();

    this.resetTimeout = setTimeout(() => {
      this.resendState = 'idle';
    }, 3000);
  }

  private startCooldown(): void {
    if (this.cooldownInterval) clearInterval(this.cooldownInterval);

    this.cooldownInterval = setInterval(() => {
      this.cooldown--;
      if (this.cooldown <= 0) {
        if (this.cooldownInterval) clearInterval(this.cooldownInterval);
        this.cooldownInterval = null;
      }
    }, 1000);
  }
}
